import { findQuestionData } from "../../../data/utils";
import { QuizData } from "../../../data/quizzData";
import {
  DEFAULT_THEME,
  ECONOMIC_THEME,
  ECONOMIC_VIABILITY,
  ENVIRONMENTAL_THEME,
  SOCIAL_THEME,
} from "../../../data/petalesAndThemes";
import React, { useState } from "react";
import { flatten } from "lodash";
import { Rose } from "@ant-design/plots";

import "../../../styles/SimpleQuizz/DisplayFlower/DemoRose.css";

//Composant qui utilise la bibliothèque ant-design pour créer le diagramme circulaire qui fait office de fleur.

const computeFlowerDataByLevelWithGrey = (userAnswers) => (level) => {
  return userAnswers.map((answer) => {
    const questionData = findQuestionData(QuizData, answer.questionId);
    return {
      petale: questionData.petale,
      theme: answer.level >= level ? questionData.theme : DEFAULT_THEME,
      level: 1,
    };
  });
};
const FLOWER_LEVELS = [4, 3, 2, 1];

const chooseFieldColor = ({ theme }) => {
  switch (theme) {
    case SOCIAL_THEME:
      return "#ED5C57";
    case ENVIRONMENTAL_THEME:
      return "#7FC79D";
    case ECONOMIC_THEME:
      return "#46B1D1";
    case DEFAULT_THEME:
    default:
      return "#F1F1F1";
  }
};

export const FlowerInside = ({ userAnswers }) => {
  const setFlowerChart = useState()[1];

  const ref = React.useRef();
  React.useEffect(() => {
    setFlowerChart(ref.current.getChart());
  }, [userAnswers]);

  const flowerData = flatten(
    FLOWER_LEVELS.map(computeFlowerDataByLevelWithGrey(userAnswers))
  );
  // Needed because the library orders the stack by the order of theme appearance in the data
  // For instance, if the first data point is ECONOMIC_THEME (ie 4/4 for the 1st answer), the external ring will be blue
  // That's why we insert a DEFAULT_THEME data point with level 0 at the beginning
  const flowerDataWithDummyValue = [
    { petale: ECONOMIC_VIABILITY.petale, theme: DEFAULT_THEME, level: 0 },
    ...flowerData,
  ];

  const config = {
    data: flowerDataWithDummyValue,
    height: 400,
    width: 400,
    isStack: true,
    seriesField: "theme",
    color: chooseFieldColor,
    xField: "petale",
    yField: "level",
    radius: 0.85,
    innerRadius: 0.17,
    sectorStyle: {
      lineWidth: 5,
    },
    legend: false,
    label: {
      offset: -200000,
    },
    tooltip: {
      customContent: (title) => {
        return `<p style="padding: 10px; border: 2px ;">${title}</p>`;
      },
    },
    interactions: [{ type: "legend-active", enable: false }],
    style: {
      lineWidth: 3,
    },
  };

  return (
    <div className="demorose" style={{ zIndex: 1000 }}>
      <Rose {...config} ref={ref} />
    </div>
  );
};
